import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '& .assignInspectorLabel': {
        lineHeight: '120%',
        letterSpacing: '0.15px',
        paddingBottom: 4,
      },
    },
    nameLabel: {
      letterSpacing: '0.25px',
    },
    divider: {
      backgroundColor: 'rgb(175,168,168)',
      width: '100%',
      margin: '12px 0px',
    },
    plusIcon: {
      marginRight: 9.67,
      height: 20,
      width: 20,
      cursor: 'pointer',
    },
    fieldInspectorGrid: {
      paddingBottom: '16px',
      '& .addFieldInspectorButton': {
        width: 'fit-content',
        height: 32,
      },
    },
    fieldInspectorButton: {
      letterSpacing: '1.25px',
    },
    commentBox: {
      borderRadius: 4,
      backgroundColor: '#1e1e1e',
    },
    addFieldInspectorIcon: {
      marginRight: 9.67,
      height: 16.67,
      width: 16.67,
      marginLeft: '-5px',
    },
    offlineMessage: {
      width: '100%',
      letterSpacing: '0.15px',
      padding: '25px 0px',
    },
    searchFeaIcon: {
      width: 20,
      height: 20,
    },
    autoComplete: {
      width: '100%',
    },
    commentsGrid: {
      paddingTop: 12,
    },
    infoFeather: {
      stroke: '#93C7EB',
      width: '16px',
      height: '16px',
      marginRight: '5px',
      marginTop: '12px',
    },
  }),
);
export default useStyles;
